import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {MatSortModule} from '@angular/material/sort';
import {MatRadioModule} from '@angular/material/radio';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatStepperModule } from '@angular/material/stepper';
import {MatListModule} from '@angular/material/list';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';




@NgModule({
  declarations: [],
  imports: [
    CommonModule,

   
    MatTableModule,
    MatIconModule,
    MatSortModule,
    MatRadioModule,
    MatMenuModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    MatStepperModule,
    MatListModule,
    MatDatepickerModule,
    MatTabsModule,
    MatSidenavModule,
    MatSelectModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule ,
    MatToolbarModule,
    MatTreeModule,
    MatNativeDateModule,
    MatGridListModule,
    MatDividerModule,
    MatTooltipModule
    
  ],
  providers :[
    
  ],
  exports: [
    MatTableModule,
    MatIconModule,
    MatSortModule,
    MatRadioModule,
    MatMenuModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    MatStepperModule,
    MatListModule,
    MatDatepickerModule,
    MatTabsModule,
    MatSidenavModule,
    MatSelectModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule,
    MatToolbarModule,
    MatTreeModule,
    MatNativeDateModule,
    MatGridListModule,
    MatDividerModule,
    MatTooltipModule,
    MatSnackBarModule

  
      
    
  ]
})
export class AngularMaterialModule { }
